<template lang="html">
    <el-row>

        <list-template
                :hasSearch="false"
                :queryParams="searchInfo"
                actionUrl="lcwpgoods/findGoodsAdminList.action"
                ref="list-template">
            <template scope="scope" slot="item">

                <div style="margin-top:10px;">
                    <el-card class="basic-margin" v-for="data in scope.datas">
                        <el-row>
                            <el-col :span="2" style="text-align:left;margin-left:20px;">
                                <img :src="data.imgLink.indexOf('http')==-1?imageUrl+data.imgLink.split(',')[0]:data.imgLink.split(',')[0]"
                                     style="width:120pt;height:120pt;"
                                     v-if="data.imgLink"></img>
                                <img alt="" style="width:120pt;height:120pt;" v-else>
                            </el-col>
                            <el-col :span="14" style="text-align:left;margin-left:80px;">
                                <p style="font-size:1.8rem;">{{data.goodsName}}
                                    <el-tag size="mini" type="success" v-if="data.carShowName">{{data.carShowName}}
                                    </el-tag>

                 <span style="margin-left:6px;">
                          <el-tag size="small" type="warning" v-if="data.authStatus == 1">待审核</el-tag>
                          <el-tag size="small" type="success" v-if="data.authStatus == 2">已通过</el-tag>
                          <el-tag size="small" type="danger" v-if="data.authStatus == 3">未通过</el-tag>

                </span>
              <span style="margin-left:6px;">
                  <el-tag size="small" type="success" v-if="data.status == 1">已上架</el-tag>
                  <el-tag size="small" type="danger" v-if="data.status == 2">未上架</el-tag>
             </span>
                                    <span style="margin-left:6px;" v-if="!(data.type =='新车' || data.type =='二手车')"> <el-tag size="small" type="success"  >商品销售数量：{{data.orderCount}} </el-tag></span>
                                </p>
                                <p>商品简介：{{data.goodsDesc}}</p>
                                <p style="color:#666;font-size:1.4rem;margin-top:10pt;font-size:18px;"><span
                                        style="color:red;">{{data.currentPrice/100}}</span> 元 <span
                                        style="color:#666;font-size:12px;" v-if="data.originalPrice">原价{{data.originalPrice/100}}元</span>
                                    <span style="font-size:12px;"
                                          v-if="data.officePrice">新车价：{{data.officePrice}}</span></p>
                                <p>{{data.channelName}} - {{data.phone}}-{{data.businessName}}</p>
                                <p style="color:red;">发布时间:{{data.createTime | dateTimeFormat}} (刷新时间：{{data.refreshTime
                                    | dateTimeFormat}})</p>
                            </el-col>

                            <el-col :span="4" style="text-align:left;margin-left:20px;">

                                <p> 排序值：{{data.sortNum}}</p>
                                <el-button @click.native.prevent="showAuthStatus(data.id)" type="text"
                                           v-if="data.authStatus == 1"> 审核
                                </el-button>
                                <el-button :confirm-input-data="{goodsId:data.id}" @onInputConfirm="$refs['list-template'].loadList()"
                                           confirm-input-text="请输入排序值"
                                           confirm-input-type="number" requestUrl="lcwpgoods/updateSortNum.action"
                                           type="text"
                                           v-confirm-input>排序
                                </el-button>
                                <el-button :confirm-data="{goodsId:data.id,status:data.status==1?2:1}" :style="{color:data.status==1?'#f56c6c':'#67c23a'}" @onConfirm="$refs['list-template'].search()"
                                           :confirm-text="data.status==1?'确定下架商品':'确定上架商品'" requestUrl="lcwpgoods/changeStatus.action"
                                           type="text"
                                           v-confirm>{{data.status==1?'下架商品':'上架商品'}}
                                </el-button>
                                <el-button @click="toEditProduct(data)" type="text">修改</el-button>
                                <el-button :confirm-data="{goodsId:data.id}" :style="{color:data.status==1?'#f56c6c':'#67c23a'}" @onConfirm="$refs['list-template'].search()"
                                           confirm-text="确定删除商品" requestUrl="lcwpgoods/delGoods.action"
                                           type="text"
                                           v-confirm>删除商品
                                </el-button>
                                <el-button @click="showJoinCarShowDialog(data)" type="text" v-belong-to-channel>参加车展
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-card>

                </div>

            </template>
        </list-template>
        <auth-goods-config ref="authGoodsConfig"></auth-goods-config>
        <auth-goods-status @onSuccess="$refs['list-template'].search()" ref="authGoodsStatus"></auth-goods-status>
        <join-goods-car-show-dialog @onSuccess="$refs['list-template'].search()"
                                    ref="joinCarShowDialog"></join-goods-car-show-dialog>
    </el-row>
</template>

<script>
import ListTemplate from '@/components/ListTemplate'
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'
import JoinGoodsCarShowDialog from '@/pages/plusbusiness/children/JoinGoodsCarShowDialog'
import authGoodsConfig from '@/pages/plusGoods/children/authGoodsConfig'
import authGoodsStatus from '@/pages/plusGoods/children/authGoodsStatus'

export default {
  name: 'goods-list',
  extends: BasicPager,
  data: function () {
    return {
      searchInfo: {
        status: null,
        opStatus: 3,
        type: null,
        keyword: null,
        authStatus: 1,
        pageNum: 1,
        pageSize: 20,
        carShowId: null
      },
      configForm: {
        goodsAuthSwitch: 1
      },
      dialogAuthFormVisible: false,
      imageUrl: Config.imageUrl,
      isAdmin: false
    }
  },
  filters: {
    statusFilter: function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 2:
          str = '已下架'
          break
        case 1:
          str = '已上架'
          break
        default:
          str = '暂无'
      }

      return str
    },
    authStatusFilter: function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 2:
          str = '已通过'
          break
        case 1:
          str = '待审核'
          break
        case 3:
          str = '拒绝通过'
      }

      return str
    }
  },
  components: {
    JoinGoodsCarShowDialog,
    authGoodsConfig,
    authGoodsStatus,
    ListTemplate
  },
  props: {
    type: {
      type: String,
      default: null
    },
    businessId: {
      type: Number,
      default: null
    }
  },
  created: function () {
    this.searchInfo.type = this.type
    if (this.businessId) {
      this.searchInfo.businessId = this.businessId
    }

    let params = this.$route.params
    if (params.carShowId) {
      this.searchInfo.carShowId = params.carShowId
    } else {
      this.searchInfo.carShowId = null
    }

    if (this.loginInfo.loginPath == 'channel') {
      this.searchInfo.channelId = this.loginInfo.loginAccountId
    }

    this.isAdmin = this.loginInfo.loginPath == 'sxb'
  },
  activated: function () {
    this.searchInfo.type = this.type
    this.searchInfo.businessId = this.$route.params.businessId

    let params = this.$route.params
    if (params.carShowId) {
      this.searchInfo.carShowId = params.carShowId
    } else {
      this.searchInfo.carShowId = null
    }

    if (this.loginInfo.loginPath == 'channel') {
      this.searchInfo.channelId = this.loginInfo.loginAccountId
    }

    this.$refs['list-template'].search()
  },
  methods: {

    showAuthPhone: function () {
      let userInfo = this.getLoginInfo()
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      }
      this.$refs['authGoodsConfig'].showAuthPhone(id)
    },
    showAuthStatus: function (id) {
      this.$refs['authGoodsStatus'].showAuthStatus(id)
    },
    onStatusChange: function (value) {
      if (value === 3) {
        this.searchInfo.status = null
        this.searchInfo.authStatus = 1
      } else {
        this.searchInfo.status = value
        this.searchInfo.authStatus = null
      }

      this.$refs['list-template'].search()
    },
    showJoinCarShowDialog (data) {
      let businessId = data.id
      let carShowId = data.carShowId
      let carShowName = data.carShowName
      this.$refs['joinCarShowDialog'].showDialog(businessId, carShowId, carShowName)
    },
    excelExport: function () {
      let userInfo = this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      let url = Config.baseUrl + '/lcwpgoods/exportGoodsAdminList.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath

      if (this.searchInfo.channelId) {
        url += '&channelId=' + this.searchInfo.channelId
      }

      if (this.searchInfo.status) {
        url += '&status=' + this.searchInfo.status
      }

      if (this.searchInfo.type) {
        url += '&type=' + this.searchInfo.type
      }

      if (this.searchInfo.keyword) {
        url += '&keyword=' + this.searchInfo.keyword
      }

      let createTime = this.searchInfo.createTimes
      if (this.searchInfo.createTimes && this.searchInfo.createTimes[0]) {
        url += '&startTime=' + createTime[0].getTime() + '&endTime=' + createTime[1].getTime()
      }

      window.open(url)
    },
    toReleaseProduct: function () {
      let carShowId = this.searchInfo.carShowId
      if (carShowId) {
        let type = this.type
        switch (type) {
          case '新车':
            this.$router.push({ name: '添加车展新车商品', params: { businessId: this.businessId, carShowId: carShowId } })
            break
          case '二手车':
            this.$router.push({ name: '添加车展二手车商品', params: { businessId: this.businessId, carShowId: carShowId } })
            break
          default:
            this.$router.push({
              name: '添加车展plus商品',
              params: { businessId: this.businessId, type: type, carShowId: carShowId }
            })
        }
      } else {
        let type = this.type
        switch (type) {
          case '新车':
            this.$router.push({ name: '添加plus新车商品', params: { businessId: this.businessId } })
            break
          case '二手车':
            this.$router.push({ name: '添加plus二手车商品', params: { businessId: this.businessId } })
            break
          default:
            this.$router.push({
              name: '添加plus商品',
              params: { businessId: this.businessId, type: type, carShowId: this.carShowId }
            })
        }
      }
    },
    toEditProduct: function (data) {
      let type = this.type
      switch (type) {
        case '新车':
          this.$router.push({ name: '修改plus新车商品', params: { goodsId: data.id, businessId: data.businessId } })
          break
        case '二手车':
          this.$router.push({ name: '修改plus二手车商品', params: { goodsId: data.id, businessId: data.businessId } })
          break
        default:
          this.$router.push({ name: '修改plus商品', params: { goodsId: data.id } })
      }
    },
    onDateTimeRangeChange: function (time) {
      let createTime = this.searchInfo.createTimes
      if (createTime && createTime[0]) {
        this.searchInfo.startTime = createTime[0].getTime()
        this.searchInfo.endTime = createTime[1].getTime()
      } else {
        this.searchInfo.startTime = null
        this.searchInfo.endTime = null
      }

      this.$refs['list-template'].search()
    }
  }
}
</script>

<style lang="css" scoped>
</style>
